export enum ETipoMovimentoComercial {
  Compras = 1,
  DevolucaoCompras = 2,
  Vendas = 3,
  DevolucaoVendas = 4,
  Servico = 5
}
